import React from "react";

import "./Testimonials.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const Testimonials = () => {
  const items = [
    {
      name: "Cristina Vasile",
      job: "Manager restaurant",
      desc: "Am ales să colaborez cu Vizibil.online pentru a crea un site de prezentare modern și optimizat SEO. Colaborarea a fost rapidă și eficientă, iar rezultatele sunt mai bune decât mă așteptam. Recomand cu încredere!",
    },
    {
      name: "Andrei Ionescu",
      job: "Antreprenor tech",
      desc: "Echipa Vizibil.online ne-a ajutat să integrăm soluții AI în platforma noastră, care acum recunoaște automat produsele din imagini. Profesionalismul și viziunea lor au făcut diferența. Sunt foarte mulțumit de colaborare!",
    },
    {
      name: "Mirela Popescu",
      job: "Consultant financiar",
      desc: "Website-ul meu personal a fost realizat exact așa cum mi-am dorit. Designul este elegant, iar funcționalitatea impecabilă. Munca echipei Vizibil.online a fost excepțională și sunt foarte mulțumită de rezultate.",
    },
    {
      name: "Bogdan Chiriac",
      job: "Fondator start-up",
      desc: "Am lucrat cu Vizibil.online pentru implementarea unui sistem AI pe site-ul nostru, iar rezultatele au fost impresionante. Proiectul a fost livrat la timp, fără probleme. O echipă de încredere!",
    },
    {
      name: "Livia Banu",
      job: "Designer interior",
      desc: "Mulțumită Vizibil.online, acum am un site profesional care îmi prezintă portofoliul. Clienții mei au fost încântați de designul și funcționalitatea site-ului. O colaborare excelentă!",
    },
    {
      name: "Daniel Costea",
      job: "Producător video",
      desc: "Am colaborat cu Vizibil.online pentru a crea o platformă modernă de streaming video cu integrare AI. Serviciile lor au fost impecabile și m-au ajutat să îmi îmbunătățesc considerabil platforma.",
    },
    {
      name: "Marina Apostol",
      job: "Avocat",
      desc: "Profesionalismul echipei Vizibil.online a fost evident în procesul de creare a site-ului meu juridic. Este optimizat pentru clienți și arată impecabil. Recomand cu încredere!",
    },
    {
      name: "Ovidiu Gherasim",
      job: "Proprietar magazin online",
      desc: "Vizibil.online a implementat soluții AI pentru recomandarea produselor pe site-ul meu, ceea ce a dus la o creștere semnificativă a vânzărilor. O echipă extrem de eficientă și profesionistă!",
    },
    {
      name: "Silvia Cojocaru",
      job: "Antrenor personal",
      desc: "Site-ul creat de Vizibil.online este extrem de intuitiv și vizual atractiv. Acum îmi pot programa antrenamentele direct online. O colaborare excelentă, cu rezultate vizibile!",
    },
    {
      name: "Radu Teodor",
      job: "Director hotelier",
      desc: "Implementarea sistemului de rezervări AI pe site-ul nostru a simplificat enorm procesul pentru clienți. Echipa Vizibil.online a făcut o muncă extraordinară și am văzut rezultate rapide.",
    },
  ];

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    initialSlide: 0,

    responsive: [
      {
        breakpoint: 1045,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 830,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="testimonials" id="reviews">
      <div className="sub-title">
        <h2 className="text-2">
          <span className="">Experiențele clienților</span>
        </h2>
        {/* <p className="p-1">
          Clienții noștri ne recomandă datorită profesionalismului și
          rezultatelor concrete obținute.
        </p> */}
      </div>
      <div className="reviews">
        <Slider {...settings}>
          {items.map((item, index) => (
            <div key={index} className="item">
              <p className="p-1 desc">{item.desc}</p>
              <p className="name">{item.name}</p>
              <span className="job">{item.job}</span>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonials;
